<template lang="pug">
  section#creative_wrap
    div.alert.alert-danger.alert-dismissible.mt-2.mb-2(v-if="radioError")
      button.close(type="button", aria-hidden="true", @click="radioError = false") ×
      | リンクの選択をしてください
    .form-check.mb-3.mt-3
      input#creatives_target_blank.form-check-input(
        type='radio',
        name='select_link_type',
        @change='setTargetBlank',
        :checked="localTargetBlank",
        value=1
      )
      label.form-check-label(for='creatives_target_blank') リンクあり（別タブ）
      p.text-muted.text-xs ※別タブでリンク先URLに遷移します
    .form-check.mb-3
      input#creatives_inner_link.form-check-input(
        type='radio',
        name='select_link_type',
        @change='setInnerLink',
        :checked="localInnerLink",
        value=1
      )
      label.form-check-label(for='creatives_inner_link') リンクあり（同じタブ）
      p.text-muted.text-xs.mb-0 ※同じタブでリンク先URLに遷移します。
      p.text-muted.text-xs ※コンバージョンの計測はできません。
    .form-check.mb-3(v-if="!hide_no_link")
      input#creatives_no_link.form-check-input(
        type='radio',
        name='select_link_type',
        @change='setNoLink',
        :checked="localNoLink",
        value=1
      )
      label.form-check-label(for='creatives_no_link') リンクなし
      p.text-muted.text-xs ※画像の表示のみで、画像をクリックしても遷移しません。
    .form-group(v-if="localNoLink == false")
      label(for='creative_link') リンク先URL
      input#creative_link.form-control(
        type='text',
        name='link',
        placeholder='リンク先のURLを入力',
        @input='setLink',
        :value="localLink"
      )
    .form-check(v-if="localTargetBlank == true")
      input#creative_with_parameters_flag.form-check-input(
        type='checkbox',
        name='with_parameters',
        @click='setWithParameters',
        :checked="localWithParameters",
        value=1
      )
      .d-flex.align-items-center.mb-3
        label.form-check-label(for='creative_with_parameters_flag') パラメータの引継ぎをする
        span.upper-master-label.ml-2 Master以上
        UpgradeUpperMaster(v-if="isUpgradeUpperMasterModal", @close-modal="isUpgradeUpperMasterModal = false")
    // 自動遷移のチェックボックス（同じタブ + 結果画像ありの場合のみ表示）
    .form-check(v-if="localInnerLink == true && has_result_image")
      input#creative_auto_transition_flag.form-check-input(
        type='checkbox',
        name='auto_transition',
        @click='setAutoTransition',
        :checked="localAutoTransition",
        value=1
      )
      .d-flex.align-items-center.mb-3
        label.form-check-label(for='creative_auto_transition_flag') 結果画像表示から5秒後、自動でリンクさせる
        span.upper-master-label.ml-2 Master以上
        UpgradeUpperMaster(v-if="isUpgradeUpperMasterModalForAutoTransition", @close-modal="isUpgradeUpperMasterModalForAutoTransition = false")
    // リンク入力欄のエラー表示
    div.alert.alert-danger.alert-dismissible.mt-2.mb-2(v-if="linkError")
      button.close(type="button", aria-hidden="true", @click="linkError = false") ×
      | リンク先URLを入力してください
  </template>

  <script>
  import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";

  export default {
    components: { UpgradeUpperMaster },
    props: {
      choice_id: {
        type: [String, Number],
        default: null
      },
      scenario_image_id: {
        type: [String, Number],
        default: null
      },
      index: {
        type: [String, Number],
        default: null
      },
      target_blank: {
        type: Boolean,
        default: false
      },
      inner_link: {
        type: Boolean,
        default: false
      },
      no_link: {
        type: Boolean,
        default: false
      },
      with_parameters: {
        type: Boolean,
        default: false
      },
      auto_transition: {
        type: Boolean,
        default: false
      },
      link: {
        type: String,
        default: ''
      },
      is_upper_master_plan:{
        type: Boolean,
        default: false
      },
      hide_no_link: {
        type: Boolean,
        default: false
      },
      has_result_image: {
        type: Boolean,
        default: true
      }
    },
    data() {


      return {
        radioError: false,
        linkError: false,
        localTargetBlank: this.target_blank,
        localInnerLink: this.inner_link,
        localNoLink: this.no_link,
        localWithParameters: this.with_parameters,
        localAutoTransition: this.auto_transition,
        isUpgradeUpperMasterModal: false,
        isUpgradeUpperMasterModalForAutoTransition: false,
        choiceAction: 'link_destination',
        localLink: this.link
      };
    },
    methods: {
      setRadioError(value) {
        this.radioError = value;
      },
      setLinkError(value) {
        this.linkError = value;
      },
      setTargetBlank() {
        this.localTargetBlank = true;
        this.localInnerLink = false;
        this.localNoLink = false;
        this.radioError = false;
        this.localAutoTransition = false; // 自動遷移フラグをリセット
      },
      setInnerLink() {
        this.localTargetBlank = false;
        this.localInnerLink = true;
        this.localNoLink = false;
        this.radioError = false;
        this.localWithParameters = false; // パラメータ引継ぎをリセット
      },
      setNoLink() {
        this.localTargetBlank = false;
        this.localInnerLink = false;
        this.localNoLink = true;
        this.radioError = false;
        this.localAutoTransition = false; // 自動遷移フラグをリセット
      },
      setLink(e) {
        this.localLink = e.target.value;
        this.linkError = false;
      },
      setWithParameters(e) {
         if (!this.is_upper_master_plan) {
          e.preventDefault();
          this.isUpgradeUpperMasterModal = true;
        } else {
          this.localWithParameters = e.target.checked;
        }
      },
      setAutoTransition(e) {
        if (!this.is_upper_master_plan) {
          e.preventDefault();
          this.isUpgradeUpperMasterModalForAutoTransition = true;
        } else {
          this.localAutoTransition = e.target.checked;
        }
      },
      // 追加：親へリンク設定の各値を返すメソッド
      getLinkSettings() {
        return {
          target_blank: this.localTargetBlank,
          inner_link: this.localInnerLink,
          no_link: this.localNoLink,
          link: this.localLink,
          with_parameters: this.localWithParameters,
          auto_transition: this.localAutoTransition
        };
      },
      // 外部から値をリセットするメソッド
      resetSettings(settings) {
        this.localTargetBlank = settings.target_blank || false;
        this.localInnerLink = settings.inner_link || false;
        this.localNoLink = settings.no_link || false;
        this.localLink = settings.link || '';
        this.localWithParameters = settings.with_parameters || false;
        this.localAutoTransition = settings.auto_transition || false;
      },
    }
  };
  </script>
